// spa-entry.js — SPA 主入口（index.html）
// 职责：CSRF 令牌注入 → 登录门禁 → Shell 初始化 → 路由分发 → 小雀 Agent 延迟加载

// Service Worker 注册（PWA 离线支持）
if ('serviceWorker' in navigator && !/localhost|127\.0\.0\.1/.test(location.hostname)) {
  navigator.serviceWorker.register('/sw.js', { scope: '/' }).then(function(reg) {
    console.log('[PWA] Service Worker 注册成功 scope=' + reg.scope);
  }).catch(function(err) {
    console.error('[PWA] Service Worker 注册失败:', err.message);
  });
}

// 窗口宽度跨越 1025px 断点时自动刷新（workspace 路由桌面/移动端模板切换）
// 横竖屏切换或窗口拉伸都可能触发
(function() {
  var BP = 1025;
  var lastIsDesktop = window.matchMedia('(min-width: ' + BP + 'px)').matches;
  var timer = null;
  window.addEventListener('resize', function() {
    if (timer) return;
    timer = setTimeout(function() {
      timer = null;
      var isDesktop = window.matchMedia('(min-width: ' + BP + 'px)').matches;
      if (isDesktop === lastIsDesktop) return;
      // 仅 workspace 路由刷新（data-workspace 标记由 injectDOMSkeleton 设置）
      if (document.querySelector('[data-workspace]')) {
        location.reload();
        return;
      }
      lastIsDesktop = isDesktop;
    }, 400);
  });
})();

import '@shared/csrf.js';
import '@shared/config.js';

import { ensureLogin } from '@shared-gate/ensure-login.js';

import { initShell } from './shell-init.js';
import { matchRoute, loadRoute } from './router.js';

(async function() {
  try {
    await ensureLogin();
  } catch (e) {
    console.error('登录检查失败', e);
  }
  initShell().then(function() {
    document.body.style.display = '';

    // 小雀 Agent 延后加载（浏览器空闲时），避免阻塞首屏渲染
    var _scheduleAgentInit = function() {
      // 先加载 CSS，等 CSS 就绪后再加载 JS 模块（避免 CSS/JS 竞速导致横幅闪烁）
      var cssLink = document.createElement('link');
      cssLink.rel = 'stylesheet';
      cssLink.href = '/assets/css/shared/secretary-chat.css';
      cssLink.onload = function() {
        import('@modules/secretary-core.js').then(function(mod) {
          mod.initSecretaryAgent();
        }).catch(function() { /* 静默失败，Agent 非关键路径 */ });
      };
      // 兜底：如果 onload 不触发（某些浏览器缓存命中时可能不触发），也加载 JS
      cssLink.onerror = function() {
        import('@modules/secretary-core.js').then(function(mod) {
          mod.initSecretaryAgent();
        }).catch(function() { /* 静默失败 */ });
      };
      document.head.appendChild(cssLink);
    };
    if (typeof requestIdleCallback === 'function') {
      requestIdleCallback(_scheduleAgentInit);
    } else {
      setTimeout(_scheduleAgentInit, 2000);
    }

    var path = location.pathname;
    // 兜底：若因旧缓存等原因在 '/' 加载了 SPA，直接别名到 /hello（服务端已不提供 / 页面）
    if (path === '/') {
      history.replaceState(null, '', '/hello');
      path = '/hello';
    }
    var route = matchRoute(path);

    // 平台自动识别：workspace 路由初始加载时，根据屏幕宽度自动跳转到对应平台
    if (route && route.type === 'workspace') {
      var isMobile = window.matchMedia('(max-width: 1024px)').matches;
      var clean = location.pathname.replace(/\/$/, '') || '/';
      if (isMobile && !clean.endsWith('-m')) {
        location.replace(clean + '-m' + location.search + location.hash);
        return;
      } else if (!isMobile && clean.endsWith('-m')) {
        location.replace(clean.replace(/-m$/, '') + location.search + location.hash);
        return;
      }
    }

    if (route) {
      loadRoute(route);
    } else {
      var root = document.getElementById('app-root');
      if (root) {
        document.title = '404 - LuMeet';
        root.innerHTML =
          '<div style="text-align:center;padding:120px 20px;">' +
          '<h1 style="font-size:72px;color:#ddd;margin:0;">404</h1>' +
          '<p style="font-size:16px;color:#888;margin:16px 0;">页面不存在</p>' +
          '<a href="/hello" data-spa-link style="color:#F688C2;">返回首页</a>' +
          '</div>';
      }
    }
  }).catch(function(err) {
    console.error('[SPA] initShell 失败:', err);
    var root = document.getElementById('app-root');
    if (root) {
      root.innerHTML =
        '<div style="text-align:center;padding:120px 20px;">' +
        '<p style="font-size:16px;color:#888;">应用初始化失败，请检查网络连接</p>' +
        '<button onclick="location.reload()" style="padding:8px 20px;border:1px solid #ddd;border-radius:6px;background:#fff;cursor:pointer;">刷新页面</button>' +
        '</div>';
    }
  });
})();
